
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import tinycolor from 'tinycolor2';

interface IAlpha {
  a?: number;
}

export type IRgb = tinycolor.ColorFormats.RGB & IAlpha;
export type IHsl = tinycolor.ColorFormats.HSL & IAlpha;
export type IHsv = tinycolor.ColorFormats.HSV & IAlpha;

export type IColorMode = 'hex' | 'rgb' | 'rgbString' | 'hsl' | 'hslString' | 'hsv' | 'hsvString';
export type IAnyColor = string | IRgb | IHsl;


export interface ICoordinatesEvent {
  x: number;
  y: number;
  top: number;
  left: number;
  width: number;
  height: number;
  $event: NzSafeAny;
}
